import {
	type SmsPack,
	type SmsSettings,
	apiAppBusinessSmssettingsGetsmssettings,
	apiAppBusinessSmssettingsPostsmssettings
} from '#lib/types/generated/index.js';
import { toSaveSmsSettingsRequest } from '#lib/helper/sms.js';
import { optimisticSet } from '#lib/stores/optimistic.js';
import { writable } from 'svelte/store';

export const smsSettingsStore = writable<SmsSettings | null>(null);

export function loadSmsSettings(): void {
	apiAppBusinessSmssettingsGetsmssettings().then((settings) => {
		smsSettingsStore.set(settings);
	});
}

export const smsPacksStore = writable<SmsPack[] | null>(null);

export function saveSmsSettings(form: SmsSettings): Promise<SmsSettings> {
	return optimisticSet(smsSettingsStore, form, () =>
		apiAppBusinessSmssettingsPostsmssettings(toSaveSmsSettingsRequest(form))
	) as Promise<SmsSettings>;
}
